module.exports = __webpack_public_path__ + "fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font-awesome-4.7.0/fonts/fontawesome-webfont.eot
// module id = 1108
// module chunks = 321